import { DangerIcon } from '../../../assets/icons'
import { ButtonCommon, ModalCommon } from '../../../components'
import styles from './index.module.scss'
import { useTranslation } from 'react-i18next'

interface IProps {
  visible: boolean
  onCancel: () => void
  onOk: () => void
  loading?: boolean
}

export const ConfirmRefetchQRCodeModal = ({ visible, onCancel, onOk, loading }: IProps) => {
  const {t} = useTranslation()
  return (
    <ModalCommon
      title={t('meter.refetchQRCode')}
      visible={visible}
      onCancel={onCancel}
      width="852px"
      destroyOnClose={true}
    >
      <div className={styles.container}>
        <div className={styles.form__content}>
          <DangerIcon />
          <p>{t('meter.message.confirmRefetch')}</p>
        </div>
        <div className={styles.form__footer}>
          <ButtonCommon type="ghost" onClick={onCancel}>
            {t('meter.cancel')}
          </ButtonCommon>
          <ButtonCommon type="primary" onClick={onOk} loading={loading}>
            {t('meter.refetch')}
          </ButtonCommon>
        </div>
      </div>
    </ModalCommon>
  )
}
